import { LANDPAGE_ENDPOINT } from './endpoint'

export const getLandpage = (slug, cb) => {
  let payload = {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR'
    }
  }

  return fetch(`${LANDPAGE_ENDPOINT}/${slug}`, payload)
    .then(response => response.json())
    .then(json => cb(json))

}



// WEBPACK FOOTER //
// ./src/api/landpage.js